@use "variables" as *;

.appStoreButton {
  display: flex;
  justify-content: center;
  margin-top: $spacing-l;
}

.androidButtonContainer {
  display: flex;
  justify-content: center;
  text-decoration: none !important;
  color: white;
}

.androidButton {
  display: flex;
  flex-direction: row;
  width: 118px;
  height: 38px;
  background-color: black !important;
  border-radius: 8px !important;
  border-width: thin;
  border-color: rgb(166, 166, 166) !important;
  align-items: center;
}

.androidButtonImage {
  width: 20px;
  height: 20px;
  padding: 10px;
}

.androidButtonTitle {
  font-size: 17px;
  font-weight: 500;
}
